import { ArrowLeft, Compass } from 'lucide-react';
import { Link } from 'react-router-dom';

type LearnerPreviewBannerProps = {
  returnTo: string;
};

export function LearnerPreviewBanner({ returnTo }: LearnerPreviewBannerProps) {
  return (
    <div className="mb-6 rounded-2xl border border-line bg-[var(--state-warning-bg)] px-4 py-4 text-state-warning">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-3">
          <div className="rounded-full border border-line bg-paper p-2 text-state-warning">
            <Compass className="h-5 w-5" />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-state-warning">
              Admin Preview
            </p>
            <p className="mt-1 text-sm text-ink/85">
              You are viewing learner surfaces intentionally from the admin console.
            </p>
          </div>
        </div>

        <Link
          to={returnTo}
          className="inline-flex items-center gap-2 self-start rounded-full border border-line bg-paper px-3 py-2 text-sm font-medium text-ink transition hover:border-line-strong hover:bg-paper-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Return to Admin
        </Link>
      </div>
    </div>
  );
}
